/**
 * Non-secret Supabase identifiers (ADR 0004). The publishable key is designed
 * to ship in the browser bundle; secret/service keys must never appear in web
 * code, configuration, or environment files.
 */
export interface SupabaseConfig {
  readonly url: string;
  readonly publishableKey: string;
}

export const supabaseConfig: SupabaseConfig = {
  url: import.meta.env.VITE_SUPABASE_URL ?? 'https://usrypfvamrharluwpxxt.supabase.co',
  publishableKey:
    import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ??
    'sb_publishable_inNDy0EqBGbo4qD56HB8jg_2ie6wiU_',
};
